var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"k-icon",class:{ 'k-load-loop': _vm.loop },style:(_vm.styles),attrs:{"aria-hidden":"true"},on:{"click":_vm.handleClick}},[_c('use',{attrs:{"xlink:href":("#icon-" + _vm.type)}})])}
var staticRenderFns = []

export { render, staticRenderFns }